export interface AllTransacoesDto {
  currentParcel: any;
  receiveDate: Date;
  parcels: any;
  paymentDate: Date,
  empresa: string,
  businessName: string;
  acquirer: number;
  terminal: number;
  tefTerminal: string;
  authorizationNumber: number;
  brand: string;
  cardNumber: number;
  productName: string;
  nsu: number;
  originalValue: number;
  status: string;
  value: number;
  liquidValue: number;
  paymentStatus: string;
  commercialHierId?: string;
  commercialHierName?: string;
}
export interface IAllLiveTransactions {
  allLiveTransactions: AllTransacoesDto[];
}

export interface ILiveTransactionsFilterProps {
  date?: string
}

export interface PainelVendasFilterProps {
  initialDate?: string;
  finalDate?: string;
  saleInitialDate?: string;
  saleFinalDate?: string;
  bandeira?: string;
  tipoPagamento?: string;
  status?: number;
  statusPagamento?: string;
  businessName?: string;
  acquirerNsu?: string;
  acquirer?: number;
  capture?: string;
  merchantId?: string;
  orderNumber?: string;
  paid?: boolean | null;
  anticipationIncluded?: boolean | null;
  Valori?: boolean;
  cancellationStatus?: number | null;
  serialNumber?: string;
  signatures?: any;
  dateFilterType?: number | null;
  commercialHierId?: string;
  parcelNumber?: number;
  parcelMin?: number | null;
  parcelMax?: number | null;
  centralizedLiquidationEnabled?: null;
  valueField?: 'gross' | 'liquid' | null;
  valueOperator?: 'greater' | 'less' | 'between' | null;
  valueMin?: number | null;
  valueMax?: number | null;
}
export enum DateFilterType {
  PAIMENTDATE = 1, //data venda
  RECEIVE = 2 //data recebiveis
}

export interface CommercialOption {
  id: number;
  commercialLevelName: string;
  responsibleName: string;
}
